<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="closeForm"
    :title="rowInfo.id===''?'添加管理员':'编辑管理员'"
    width="60%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="管理员姓名" prop="userName">
              <el-input v-model="rowInfo.userName" placeholder="管理员姓名" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="rowInfo.phone" placeholder="电话" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="rowInfo.email" placeholder="邮箱" style="width: 220px"/>
            </el-form-item>
          </el-col>
           <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <select-text v-model="rowInfo.status" code-set-id="0" placeholder="状态" style="width: 220px"/>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名"  prop="loginName">
              <el-input v-model="rowInfo.loginName" placeholder="用户名" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户密码" prop="password">
              <el-input type="password"  v-model="rowInfo.password" placeholder="用户密码" maxlength="50" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                :autosize="{ minRows: 3, maxRows: 5}"
                v-model="rowInfo.remark"
                placeholder="备注"
                type="textarea"
                resize = "none"
                style="width:90%;"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import SelectText from '@/components/SelectText/index.vue'
import { addProjectAdminInfo,getProjectAdminInfo } from  "@/api/project/index"
export default {
  components: {
    SelectText
  },
  data() {
    let validateUserName = (rule, value, callback) => {
      let partern=/^[a-zA-Z]{1}([a-zA-Z0-9]|[._]){4,19}$/;
      if (!partern.test(value)) return callback(new Error('请输入5位以上的字母数字组合'))
      callback()
    }
    // 手机号
    let validatePhone = (rule, value, callback) => {
      let isNum = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value && !isNum.test(value)) {
        callback(new Error('请输入正确的电话'))
      }
      callback()
    }
    let validateEmail = (rule, value, callback) => {
      let isNum = /^\w+([-+.]\w+)*@\w+([-.]\w+)*.\w+([-.]\w+)*$/
      if (value && !isNum.test(value)) {
        callback(new Error('请输入正确的邮箱'))
      }
      callback()
    }
    return {
      visible: false,
      formName: '新增',
      loading: false,
      rowInfo: {
        id: '',
        projectId: '',
        userName: '',
        phone: '',
        email: '',
        loginName: '',
        password: '',
        oldPassword: '',
        status: "1",
        remark: ''
      },
      rules: {
        userName: [{ required: true, message: '必填:管理员姓名', trigger: 'blur' }],
        loginName: [{ required: true, message: '必填:用户名', trigger: 'blur' },
          { validator: validateUserName, trigger: 'blur' }],
        password: [{ required: true, message: '必填:密码', trigger: 'blur' }],
        status: [{ required: true, message: '必填:状态', trigger: 'change' }],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
  },
  methods: {
    init(projectId,id) {
      this.visible = true
      this.rowInfo.projectId = projectId
      if (id) {
        this.rowInfo.id = id
        getProjectAdminInfo(id).then((res) => {
            if(res.data.code==0){
              let data = res.data
              this.rowInfo = data.data
              this.rowInfo.oldPassword = this.rowInfo.password
            }
        })
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addProjectAdminInfo(this.rowInfo).then((res) => {
            if (res.data.code==0) {
              // 在store中改变修改的值
              if (this.rowInfo.id) {
                this.$message.success("编辑成功")
              } else {
                this.$message.success("添加成功")
              }
              // 子组件中触发父组件的初始化方法
              this.$emit('refresh', '')
              // 关闭弹框
              this.closeForm()
            }
          })
        } else {
          return false
        }
      })
    },
    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields()
      this.rowInfo = {
        id: '',
        projectId:'',
        userName: '',
        phone: '',
        email: '',
        loginName: '',
        password: '',
        oldPassword: '',
        status: "1",
        remark: ''
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>
